import { render } from "./HonoreeFormCheckboxField.vue?vue&type=template&id=3578358e"
import script from "./HonoreeFormCheckboxField.vue?vue&type=script&lang=js"
export * from "./HonoreeFormCheckboxField.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__